import AddVendor from '../../pages/Vendor/AddVendor';
import { VendorController } from '../../controllers';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import { MimaToastUtil } from '../../components';
import { phoneRegExp } from '../../utils/utils';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';
import { userStore } from '../../stores';

const AddVendorContainer = ({ closeModal, goBack, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.VENDORADD);

	const vendorDetailsValidation = () => {
		return yup.object({
			name: yup.string().required('Vendor name is required'),
			businessCategory: yup.string().required('Vendor category is required'),
			services: yup.string().required('Vendor services is required'),
			mobile: yup.string().matches(phoneRegExp, 'Phone number is not valid').required('Vendor phone number is required'),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			}
		}

		const { status, errorMessage } = await VendorController.createVendor(
			payload
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<AddVendor
			closeModal={closeModal}
			loading={loading}
			onSubmit={onSubmit}
			vendorDetailsValidation={vendorDetailsValidation}
			goBack={goBack}
		/>
	);
};

export default observer(AddVendorContainer);
